/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Privacypolicy_Description1Inputs */

const he_seo_privacypolicy_description1 = /** @type {(inputs: Seo_Privacypolicy_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מדיניות הפרטיות של Pricedrop — כיצד אנו אוספים, משתמשים ומגנים על המידע שלכם.`)
};

const en_seo_privacypolicy_description1 = /** @type {(inputs: Seo_Privacypolicy_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn how Pricedrop collects, uses, and protects your personal information.`)
};

/**
* | output |
* | --- |
* | "Learn how Pricedrop collects, uses, and protects your personal information." |
*
* @param {Seo_Privacypolicy_Description1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const seo_privacypolicy_description1 = /** @type {((inputs?: Seo_Privacypolicy_Description1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Privacypolicy_Description1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_privacypolicy_description1(inputs)
	return en_seo_privacypolicy_description1(inputs)
});
export { seo_privacypolicy_description1 as "seo_privacyPolicy_description" }